import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { useToast } from '../context/ToastContext.jsx';
import CuentasDemo from '../components/CuentasDemo.jsx';
import FondoNebulosa from '../components/FondoNebulosa.jsx';
import { VERSION } from '../version.js';

// Servicios de Growing Solutions CR tal como los publica su sitio
// (Apps_Growing/gsline/src/constants/company.js), agrupados con las mismas
// categorias de sus paquetes. Estan los 11: no agregar ninguno que el
// sitio no ofrezca.
const AREAS_GROWING = [
  {
    icono: 'web',
    titulo: 'Landing pages y sitios',
    servicios: ['Landing Pages Cinemáticas', 'Sitios Web Corporativos'],
  },
  {
    icono: 'sistemas',
    titulo: 'Sistemas y plataformas',
    servicios: ['Plataformas y Sistemas a Medida', 'Control de Inventarios', 'Análisis de Datos & Reportes'],
  },
  {
    icono: 'automatizacion',
    titulo: 'Automatización',
    servicios: ['Automatización de Procesos', 'Cobros y Campañas Automáticas'],
  },
  {
    icono: 'asesoria',
    titulo: 'Asesorías y acompañamiento',
    servicios: [
      'Diagnóstico Digital Estratégico', 'Educación Tecnológica',
      'Renovación Digital & Mejora de Procesos', 'Acompañamiento Continuo',
    ],
  },
];

// Sitio y redes de Growing Solutions CR. Cada area de la vitrina abre el
// sitio; el boton del pie abre Instagram.
const SITIO_GROWING = 'https://growingsolutionscr.com';
const INSTAGRAM_GROWING = 'https://www.instagram.com/growingsolutions_cr/';

// Marca de FacturaGS para la entrada: el logo completo, el rayo en forma de
// F y el nombre. "Factura" viene en blanco dentro de la imagen, asi que
// este logo solo va sobre fondo oscuro; en fondos claros va el isotipo.
// Growing ya aparece en el pie; aca manda el producto.
const LogoFacturaGS = () => (
  <div className="lg-logo-marca">
    <img src="/facturags-logo.webp" alt="FacturaGS" width="637" height="533" />
  </div>
);

// Iconos de las areas (trazos de linea, como el resto del sistema).
const TRAZOS_AREA = {
  web: (
    <>
      <rect x="2" y="3" width="20" height="14" rx="2" />
      <path d="M8 21h8M12 17v4" />
    </>
  ),
  sistemas: (
    <>
      <path d="M12 2 2 7l10 5 10-5-10-5z" />
      <path d="m2 17 10 5 10-5M2 12l10 5 10-5" />
    </>
  ),
  automatizacion: (
    <>
      <path d="M23 4v6h-6M1 20v-6h6" />
      <path d="M3.5 9a9 9 0 0 1 14.9-3.4L23 10M1 14l4.6 4.4A9 9 0 0 0 20.5 15" />
    </>
  ),
  asesoria: (
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="m16.2 7.8-2.1 6.3-6.3 2.1 2.1-6.3z" />
    </>
  ),
};
const IconoArea = ({ tipo }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {TRAZOS_AREA[tipo]}
  </svg>
);

// Glifo de Instagram. Se dibuja aca porque solo vive en esta pantalla.
const Instagram = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);

export default function Login() {
  const { login } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [cargando, setCargando] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setCargando(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.message || 'No se pudo iniciar sesion');
    } finally {
      setCargando(false);
    }
  };

  const usarDemo = (correo, clave) => { setEmail(correo); setPassword(clave); };

  return (
    <div className="lg-escena">
      {/* Fondo CrimsonNebula en morado: nebulosa animada, decorativa. */}
      <FondoNebulosa />
      <span className="lg-version"><span className="lg-version-nombre">FacturaGS </span>v{VERSION}</span>

      <div className="lg-tarjeta">
        {/* ---- Marca ---- */}
        <div className="lg-marca">
          <div className="lg-logo">
            <LogoFacturaGS />
          </div>

          {/* Vitrina de Growing Solutions. Quien entra ya confia en FacturaGS:
              aca se le cuenta que el mismo equipo hace mas por su negocio.
              Cada area abre el sitio de Growing. */}
          <div className="lg-vitrina">
            <h2 className="lg-vitrina-titulo">Más allá de facturar</h2>
            <p className="lg-vitrina-bajada">
              <strong>Growing Solutions CR</strong>, el equipo detrás de FacturaGS, crea
              soluciones digitales que generan resultados reales.
            </p>
            <ul className="lg-areas" aria-label="Servicios de Growing Solutions CR">
              {AREAS_GROWING.map((a) => (
                <li key={a.titulo}>
                  <a href={SITIO_GROWING} target="_blank" rel="noopener noreferrer">
                    <span className="lg-area-icono"><IconoArea tipo={a.icono} /></span>
                    <span className="lg-area-texto">
                      <strong>{a.titulo}</strong>
                      {/* El punto va pegado al servicio anterior (espacio que no
                          corta): asi nunca queda un "·" al inicio de una linea. */}
                      <span>
                        {a.servicios.map((s, i) => (i < a.servicios.length - 1 ? `${s}\u00a0· ` : s)).join('')}
                      </span>
                    </span>
                    <svg className="lg-area-flecha" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="m9 18 6-6-6-6" />
                    </svg>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg-pie">
            <img src="/growing-g.png" alt="" className="lg-pie-logo" />
            <span className="lg-pie-texto">
              FacturaGS es un producto de <strong>Growing Solutions CR</strong>
            </span>
            <a
              className="lg-instagram" href={INSTAGRAM_GROWING}
              target="_blank" rel="noopener noreferrer"
              aria-label="Growing Solutions CR en Instagram"
            >
              <Instagram /> Instagram
            </a>
          </div>
        </div>

        {/* ---- Formulario ---- */}
        <div className="lg-form">
          <h1>Bienvenido de vuelta</h1>
          <p className="lg-sub">Ingresa tus credenciales para continuar</p>

          <form onSubmit={submit}>
            <div className="lg-campo">
              <label htmlFor="lg-correo">Correo electronico</label>
              <input
                id="lg-correo" type="email" value={email} required
                autoComplete="username" autoFocus
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@correo.cr"
              />
            </div>
            <div className="lg-campo">
              <label htmlFor="lg-clave">Contrasena</label>
              <input
                id="lg-clave" type="password" value={password} required
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>

            <button className="lg-entrar" disabled={cargando}>
              {cargando ? <span className="spinner" /> : 'Iniciar sesion'}
            </button>
          </form>

          <div className="lg-demo-envoltorio">
            <CuentasDemo onUsar={usarDemo} />
          </div>
        </div>
      </div>
    </div>
  );
}
